import { IncludeParams } from '../types';

const params: IncludeParams = {
  nowInRuntime: null,
  activedModulesList: [],
  modulesState: [],
};

let counter!: NodeJS.Timeout;
const customContext: { data: { [key: string]: any } } = { data: {} };

const ErrorHandlers: {
  [key: string]: (error: string, errors: { [key: number]: string }) => void;
} = {};

// const errors: { [key: string]: any } = {};

/**
 * @description subscribe error bindary
 * @param name module name
 * @param fn callback
 */
// export function subscribeError(
//   name: string,
//   fn: (error: string, errors: { [key: number]: string }) => void
// ): void {
//   if (!errors[name]) {
//     errors[name] = new Proxy<typeof errors>(
//       {},
//       {
//         set: (target, prop: string, value) => {
//           target[prop] = value;
//           fn(value, target);
//           return true;
//         },
//       }
//     );
//   }
// }

export function subscribeError(
  name: string,
  fn: (error: string, errors: { [key: number]: string }) => void,
): void {
  ErrorHandlers[name] = fn;
}

/**
 * @description Dispatch error bindary
 * @param name module name
 * @param error module error string
 */
export function dispatchError(name: string, error: string): void {
  // errors[name][Object.keys(errors[name]).length] = error;
  const errorHandler = ErrorHandlers[name];
  errorHandler && errorHandler(error, {});
}

/**
 * @description Adding a processed module
 */
function setRuntimeModule(module: string): void {
  clearTimeout(counter);
  params.nowInRuntime = module;
  counter = setTimeout(() => {
    params.nowInRuntime = null;
  }, 1000);
}

/**
 * @description Adding by modle list
 * @param module name string
 */
function addModuleByList(module: string): void {
  params.activedModulesList.push(module);
}

/**
 * @description Adding a module state
 * @param name name string
 * @param state success | error
 */
function setModuleState(name: string, state: 'success' | 'error'): void {
  params.modulesState.push({ name, state });
}

/**
 * @description Get injected context
 * @return context fields and methods
 */
export function getContext(): IncludeParams {
  return { ...params };
}

/**
 * @description Att data by custom context.
 * @param payload payload data
 */
export function createCustomContext<T = { [key: string]: any }>(
  payload: T,
): void {
  customContext.data = { ...customContext.data, ...payload };
}

/**
 * @description Get custom context.
 */
export function getCustomContext(): {
  [key: string]: any;
} {
  return customContext.data;
}

function getScopeProp(obj: { [key: string]: any }, key: string): any {
  if (obj[key] === null) {
    return obj[key];
  }

  if (obj[key] instanceof Window) {
    return null;
  }

  if (obj[key] instanceof Document) {
    return obj[key];
  }

  if (Array.isArray(obj[key])) {
    return [...obj[key]];
  }

  if (typeof obj[key] === 'object') {
    return { ...obj[key] };
  }

  if (typeof obj[key] === 'function') {
    return (...args: any[]) => {
      return obj[key](...args);
    };
  }

  return obj[key];
}

export function createProxy(): {
  [key: string]: any;
} {
  return new Proxy<{ [key: string]: any }>(
    {},
    {
      get: (target, prop: string) => {
        if (!target[prop]) {
          return getScopeProp(window, prop);
        }

        return target[prop];
      },
      set: (target, prop: string, value) => {
        target[prop] = value;
        return true;
      },
    },
  );
}

export const context = {
  getContext,
  setRuntimeModule,
  addModuleByList,
  setModuleState,
};
